.moving-fibre-upgrade {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-family: $font-family-02;
  padding: $space-05 $space-04 0 $space-04;

  &__container {
    font-family: $font-family-02;
    display: flex;
    flex-direction: column;
  }

  h1 {
    font-size: $font-size-sm-07;
    font-weight: $font-weight-semi-bold;
  }

  h2 {
    font-size: $font-size-sm-06;
    font-weight: $font-weight-semi-bold;
  }

  h3 {
    font-size: $font-size-md-04;
  }

  p {
    line-height: 28px;
    font-weight: $font-weight-regular;
  }

  a {
    font-size: $font-size-sm-03 !important;
  }

  b {
    color: black !important;
    font-weight: $font-weight-bold;
  }
}
